<template>
  <v-dialog v-model="show" width="30%">
    <v-card>
      <v-card-title>
        <span class="headline">経理用データ作成</span>
      </v-card-title>

      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="年：" v-model="year"></v-text-field>
              <v-text-field label="月：" v-model="month"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-card-actions>
        <v-btn @click="download">下载</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['query'],
  data() {
    return {
      show: false,
      year: '',
      month: ''
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    download() {}
  }
}
</script>
